import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X, User, LogOut } from "lucide-react";
import { LOGO_URL } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/delivery", label: "Delivery" },
  { to: "/transfer", label: "Transfer" },
  { to: "/otc-store", label: "OTC Store" },
  { to: "/immunizations", label: "Immunizations" },
  { to: "/partners", label: "Partners" },
  { to: "/telemed", label: "TeleMed" },
  { to: "/shipping", label: "Shipping" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-white/95 backdrop-blur">
      <nav className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img src={LOGO_URL} alt="Crystal Pharmacy" className="h-12 w-auto" />
        </Link>

        <div className="hidden items-center gap-1 lg:flex">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive ? "text-primary" : "text-foreground hover:text-primary"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden items-center gap-2 lg:flex">
          {user && user.role === "patient" ? (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate("/portal")} data-testid="nav-portal">
                <User className="mr-1 h-4 w-4" /> {user.name?.split(" ")[0] || "Portal"}
              </Button>
              <Button variant="outline" size="sm" onClick={logout} data-testid="nav-logout">
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          ) : (
            <Button size="sm" className="rounded-full px-5" onClick={() => navigate("/portal")} data-testid="nav-patient-portal">
              Patient Portal
            </Button>
          )}
        </div>

        <button className="lg:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-border bg-white lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col p-4">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm font-medium ${isActive ? "bg-secondary text-primary" : "text-foreground"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Button className="mt-3 rounded-full" onClick={() => { setOpen(false); navigate("/portal"); }}>
              Patient Portal
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
